import { render, staticRenderFns } from "./create-step-1.vue?vue&type=template&id=06bd80d0&"
import script from "./create-step-1.vue?vue&type=script&lang=js&"
export * from "./create-step-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports